export default "__VITE_ASSET__CYGUhNk5__"